module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-list"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list.length !== 0),
      expression: "list.length !== 0"
    }],
    staticClass: "order-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "table-body"
    }, [_c('td', {
      staticClass: "no"
    }, [_vm._v(_vm._s(item.no))]), _vm._v(" "), _c('td', {
      staticClass: "sign-date"
    }, [_vm._v(_vm._s(item.signDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(item.statusName))]), (item.isFI) ? _c('a', {
      staticClass: "perfect-information",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.perfectInformation(item.productName)
        }
      }
    }, [_vm._v("(完善信息)")]) : _vm._e()]), _vm._v(" "), _c('td', [(item.isInfo) ? _c('router-link', {
      staticClass: "opreation detail",
      attrs: {
        "to": ("/u/order/detail?no=" + (item.no))
      }
    }, [_vm._v("详情")]) : _vm._e(), _vm._v(" "), (item.isFbs) ? _c('router-link', {
      staticClass: "opreation process",
      attrs: {
        "to": ("/u/order/process?no=" + (item.no))
      }
    }, [_vm._v("借款进度")]) : _vm._e(), _vm._v(" "), (item.isAutho) ? _c('a', {
      staticClass: "opreation bind",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.getRepaymentCard(item.no)
        }
      }
    }, [_vm._v(_vm._s(item.authoName))]) : _vm._e(), _vm._v(" "), (item.isRP) ? _c('a', {
      staticClass: "opreation plan",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.getRepaymentPlan(item.no)
        }
      }
    }, [_vm._v("还款计划")]) : _vm._e()], 1)])
  })], 2), _vm._v(" "), _c('Loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list.length === 0),
      expression: "list.length === 0"
    }],
    attrs: {
      "height": 400,
      "is-no-more": _vm.listNoMore
    }
  }, [_c('div', {
    staticClass: "no-result",
    slot: "nomore"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/noresult.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_c('p', [_vm._v("暂无借款订单")])]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('router-link', {
    attrs: {
      "to": "/borrow"
    }
  }, [_vm._v("立即申请借款")])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "table-head"
  }, [_c('th', [_vm._v("业务编号")]), _vm._v(" "), _c('th', [_vm._v("签约日期")]), _vm._v(" "), _c('th', [_vm._v("产品名称")]), _vm._v(" "), _c('th', [_vm._v("业务状态")]), _vm._v(" "), _c('th', [_vm._v("操作")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-83476864"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/order-list.vue
// module id = 617
// module chunks = 1